import { gql } from '@apollo/client';

export default gql`
  mutation DeleteProductComponentOtherProductMutation(
    $productComponentOtherProductId: Int!
  ) {
    deleteProductComponentOtherProductById(
      input: { id: $productComponentOtherProductId }
    ) {
      productComponentOtherByProductComponentOtherId {
        id
      }
    }
  }
`;
